// What an issue text comment may be — the backend's rule (`issues.schemas.ts`:
// 1 to 2000 characters), enforced at the composer so a long comment can't be
// typed only to be refused on send.

export const ISSUE_COMMENT_MAX_LENGTH = 2000;
